import React, { useState, useEffect } from 'react';
import { DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import actions from '../../actions';
import spreeStore from '../../store';

const MunicipalitySelectorModal = (props) => {
    const {
        currentZoneMunicipalities,
        isOpen,
        handleClose,
        intl,
    } = props;
    const defaultMunicipality = {
        id: -1,
        name: intl.formatMessage({
            id: 'select',
            defaultMessage: 'Select',
        }),
    };
    const [selectedMunicipality, setSelectedMunicipality] = useState(defaultMunicipality);

    useEffect(() => {
        if (isOpen) {
            setSelectedMunicipality(defaultMunicipality);
            spreeStore.dispatch(actions.setIsMunicipalityPromptModalOpen(true));
        } else {
            spreeStore.dispatch(actions.setIsMunicipalityPromptModalOpen(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const onClose = (selectedMunicipality) => {
        handleClose(selectedMunicipality);
        spreeStore.dispatch(actions.setIsMunicipalityPromptModalOpen(false));
    };

    const isModalValid = () => selectedMunicipality.id !== -1;
    return (
        <Modal show={isOpen} aria-labelledby="contained-modal-title-lg" id="modal-municipality-selector">
            <Modal.Header>
                <Modal.Title id="contained-modal-title-lg">
                    <FormattedMessage id="modal-municipalitySelect-title" defaultMessage="Please select a municipality" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <FormattedMessage id="modal-municipalitySelect-text1" defaultMessage="Por favor, seleccione el municipio en el que desea entregar los productos:" />
                </p>
                <br />
                <div>
                    <DropdownButton id="dropdown-basic-button" as="button" className="button-cancel button-small" title={selectedMunicipality.name}>
                        {currentZoneMunicipalities.map((municipality) => (
                            <MenuItem
                                as="button"
                                className="button-secondary inv button-small"
                                id={municipality.id}
                                key={municipality.id}
                                onClick={() => {
                                    setSelectedMunicipality(municipality);
                                }}
                            >
                                {municipality.name}
                            </MenuItem>
                        ))}
                    </DropdownButton>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    disabled={!isModalValid()}
                    type="button"
                    style={{ marginRight: '5px' }}
                    className="button-secondary button-small"
                    onClick={() => onClose(selectedMunicipality)}
                >
                    <FormattedMessage id="modal-zoneSelect-accept" defaultMessage="Accept" />
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default injectIntl(MunicipalitySelectorModal);



/** WEBPACK FOOTER **
 ** ./src/components/shared/municipality-selector-modal.js
 **/